export const API_BASE_URL_HTTP = process.env["API_BASE_URL_HTTP"];
export const API_BASE_URL_HTTP_COMMONS_CB =
  process.env["ENV"] === "prod"
    ? `http://mapi.mmt.mmt`
    : `http://mapi.makemytrip.com`;

export const API_ROUTE_PREFIX = "/ext/api/v1/partners";
export const API_ROUTE_V2_PREFIX = "/ext/api/v2/partners";
export const API_ROUTE_PREFIX_HTTPS = "/insurance/ext/api/v1/partners";
export const API_ROUTE_V2_PREFIX_HTTPS = "/insurance/ext/api/v2/partners";
export const API_ROUTE_PREFIX_COMMONS_CB = "/commons-cb/api/v1/mmt";

export const API_TIMEOUT_IN_MS = 10000;

export enum API_ROUTES {
  GET_ORDERS_RETAIL_MYPARTNER = "mmt/insurance/mypartner/cb/orders",
  HIT_RETAIL_CONSENT = "mmt/insurance/mypartner/cb/registerConsent",
  GET_LANDING_PAGE_DETAILS_MY_PARTNER = "mmt/insurance/mypartner/cb/landing",
  GET_NEXT_PAGE_ROUTE_MYPARTNER = "mmt/insurance/mypartner/cb/nextPageData",
  GET_LANDING_PAGE_DETAILS = "insurance/cb/landing",
  GET_PRODUCT_LISTING = "insurance/cb/quotes",
  GET_TRAVEL_ATTRIBUTES = "insurance/cb/travelattributes",
  PAYMENT_CHECKOUT = "insurance/cb/checkout",
  GET_PASSPORT_DETAILS = "insurance/cb/passportDetails",
  EDIT_INSURANCE_DETAILS = "insurance/cb/endorsement",
  ORDER_CONFIRMED = "insurance/cb/thankyou",
  ORDER_LISTING = "insurance/cb/orders",
  ORDER_DETAIL = "insurance/cb/orderDetail",
  TRIGGER_EMAIL = "insurance/cb/email",
  GET_NEXT_PAGE_ROUTE = "insurance/cb/nextPageData",
  CHECK_CHECKOUT_ELIGIBILITY = "insurance/cb/login/eligibility",
  GET_COMMON_LANDING_PAGE_DETAILS = "insurance/cb/common-landing",
  GET_ENTRYPOINT_LANDING_PAGE_DATA = "insurance/cb/entrypoint",
  GET_GENERIC_PATH = "insurance/cb",
  GET_SUGGESTIONS_INFO = "insurance/cb/employees/autosuggest",
  GET_COMMONS_HEADER_DATA = "desktop/header",
  DOWNLOAD_TEMPLATE = "insurance/cb/files/download",
  UPLOAD_TEMPLATE = "insurance/cb/excel-upload",
}

export const CMS_API_BASE_URL =
  process.env["CMS_API_BASE_URL"] || "http://tripmoney-insurance.mmt.com";

export const SEO_PAGES_QUERY_ID = {
  LANDING_PAGE_DEFAULT: "seo-insurance-landing-default",
  LANDING_PAGE_COUNTRY: "seo-insurance-landing-country-default",
  LANDING_PAGE_DEFAULT_GI: "seo-insurance-gi-landing-default",
  LANDING_PAGE_COUNTRY_GI: "seo-insurance-gi-landing-country-default",
};

export const SEO_PAGES_V2_QUERY_ID = {
  LANDING_PAGE_COUNTRY: "seo-insurance-landing-v2-country-default",
  LANDING_PAGE_COUNTRY_GI: "seo-insurance-gi-landing-v2-country-default",
};
